import { render, staticRenderFns } from "./EntityFieldDetailedView.vue?vue&type=template&id=da7e97aa&scoped=true"
import script from "./EntityFieldDetailedView.vue?vue&type=script&lang=js"
export * from "./EntityFieldDetailedView.vue?vue&type=script&lang=js"
import style0 from "./EntityFieldDetailedView.vue?vue&type=style&index=0&id=da7e97aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da7e97aa",
  null
  
)

export default component.exports